import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { Word } from '@attain-apps/string-builder'

import type * as models from '../../../../models'

import type { State } from './state'

/**
 * Core actions for this feature
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    setSlideout: store.actions.standalone({
      data: ({
        widgetRef,
      }: {
        widgetRef?: ents.core.mosaic.Widget.Ref
      }): models.widget.Ref | undefined =>
        widgetRef && {
          ...widgetRef,
          // Keep each slideout instance distinct so widget variable overrides
          // and rendering state don't bleed across repeated openings.
          id: Word.generate(),
        },
      reducer: ({ data, state }) => ({
        ...state,
        widgetRef: data,
      }),
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
